import React, {
  useEffect,
  useState
} from "react";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import OfferForm from "../components/OfferForm";

import {
  useOffers
} from "../hooks/useOffers";

import {
  OFFER_STATUS
} from "../constants/offer.constants";

import Loader from "../../../components/common/Loader";
import ErrorMessage from "../../../components/common/ErrorMessage";
import EmptyState from "../../../components/common/EmptyState";
import Button from "../../../components/common/Button";


const EditOfferPage = () => {
  const {
    id
  } = useParams();

  const navigate =
    useNavigate();


  const {
    getOffer,
    updateOffer,
    loading,
    error
  } = useOffers();


  const [
    offer,
    setOffer
  ] = useState(null);


  const [
    pageError,
    setPageError
  ] = useState(null);


  useEffect(() => {
    loadOffer();
  }, [id]);


  const loadOffer =
    async () => {

      try {

        const result =
          await getOffer(id);


        const data =
          result?.data ||
          result;


        setOffer(data);

      } catch (err) {

        setPageError(
          err?.message ||
          "Unable to load offer"
        );
      }
    };


  const handleSubmit =
    async (formData) => {

      try {

        const updated =
          await updateOffer(
            id,
            formData
          );


        const data =
          updated?.data ||
          updated;


        navigate(
          `/offers/${data.id || id}`
        );

      } catch (err) {

        setPageError(
          err?.message ||
          "Unable to update offer"
        );
      }
    };


  if (
    loading &&
    !offer
  ) {
    return <Loader />;
  }


  if (
    pageError &&
    !offer
  ) {
    return (
      <div className="edit-offer-page">

        <ErrorMessage
          message={pageError}
        />

        <Button
          onClick={() =>
            navigate("/offers")
          }
        >
          Back to Offers
        </Button>

      </div>
    );
  }


  if (!offer) {
    return (
      <EmptyState
        title="Offer not found"
        message="The requested offer could not be found."
      />
    );
  }


  if (
    offer.status !==
    OFFER_STATUS.DRAFT
  ) {
    return (
      <div className="edit-offer-page">

        <div className="page-header">
          <div>
            <h1>
              Offer cannot be edited
            </h1>

            <p>
              Only DRAFT offers can
              be edited.
            </p>
          </div>
        </div>


        <div className="offer-readonly-message">

          <p>
            This offer is currently
            <strong>
              {" "}
              {offer.status}
            </strong>.
          </p>

          <Button
            onClick={() =>
              navigate(
                `/offers/${offer.id}`
              )
            }
          >
            View Offer
          </Button>

        </div>

      </div>
    );
  }


  return (
    <div className="edit-offer-page">

      <div className="page-header">

        <div>
          <h1>
            Edit Offer
          </h1>

          <p>
            {offer.offer_number}
          </p>
        </div>

      </div>


      {pageError && (
        <ErrorMessage
          message={pageError}
        />
      )}


      <OfferForm
        mode="edit"
        initialData={offer}
        onSubmit={
          handleSubmit
        }
        onCancel={() =>
          navigate(
            `/offers/${offer.id}`
          )
        }
      />

    </div>
  );
};


export default EditOfferPage;